/*
* WHYAT Baseline Custom Javascript
*/
document.addEventListener("DOMContentLoaded", function(event) {
   
  /*
  * Add Google Maps to footer
  */
  const googlemapsListFooter = `
     <li class="googlemapsli ml-2 mb-2 inline-block">
            <a class="fill-current hover:text-scheme-accent" href="https://www.google.com/maps?daddr=Strauchgasse+1-3+1010+Wien" target="_blank">
              <span class="firstspan inline-block w-5 h-5" aria-hidden="true">
                <span class="mapicon" >&nbsp;</span>
<span class="visually-hidden">Instagram</span>
              </span>
            </a>
        </li>
    `;

  const socialmediaFooterList = document.querySelector('.socialmediaFooterContainer li:last-child');
  socialmediaFooterList.insertAdjacentHTML('afterend', googlemapsListFooter);

 
});


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("optionize-app").forEach(app => {
    const textareas = app.querySelectorAll("textarea.oz__option-element-textarea");
    textareas.forEach(textarea => {
      if (!textarea.hasAttribute("aria-label")) {
        // Labeltext suchen
        const labelEl = app.querySelector(".oz__option-label");
        const labelText = labelEl ? labelEl.textContent.trim() : "PERSONALIZE YOUR JEWELLERY WITH A COMPLIMENTARY LETTER CHARM.";
        
        textarea.setAttribute("aria-label", labelText);
      }
    });
  });
});

